import React from 'react';
import {Button, Col,ControlLabel, Form, FormControl, FormGroup, Modal} from 'react-bootstrap';
import './styles.css'
import {personFullName} from "../../../../../../services/Api";
import ReactTags from 'react-tag-autocomplete'
import PropTypes from 'prop-types';


class MailDetailModal extends React.Component{

    static contextTypes = { api:PropTypes.object };

    constructor(props){
        super(props);
        this.state = {
            subject : props.emailDocument.subject,
            header: props.emailDocument.header,
            footer: props.emailDocument.footer,
            body: props.emailDocument.body,
            mailerTags:props.emailDocument.mailerTags,
            emailAddresses:props.emailDocument.emailAddresses,
            people:props.emailDocument.people,
            plainEmails:props.emailDocument.plainEmails,
            excludedEmailAddresses:
                props.emailDocument.excludedEmailAddresses
                ? props.emailDocument.excludedEmailAddresses.map( e => ({name: e}) )
                : []

        }
    }
    getFormValue = ( name )=>{
        if(name==='to'){
            let emails = this.state.emailAddresses.map((ea) => {return {'name':ea.email, 'icon': "fa fa-address-book-o"}});
            let ppl = this.state.people.map((ea) => {return {'name':personFullName(ea),'icon': "fa fa-users"}});
            let tags = this.state.mailerTags.map((ea) => {return {'name':ea.name, 'icon':"fa fa-tag"}});
            let plain = this.state.plainEmails.map((ea) => {return {'name':ea}});
            return emails.concat(tags,ppl,plain);
        }
        return this.state[name]? this.state[name]:''
    };

    noop = () => {return null;};

    downloadFile = ( {target} )=>{
        const fileId = target.dataset.id;
        this.context.api.appFiles.download( fileId );
    };

    render(){
        const {onHide} = this.props;
        return (
            <Modal
                bsSize="large"
                show={true}
                onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Detalle de correo</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="container-fluid MailDetailForm">
                        <div className="row">
                            <div className="col-md-12">
                                <FormGroup controlId="formHorizontalEmail">
                                    <Col componentClass={ControlLabel} sm={2}>*&nbsp;Destinatarios:</Col>
                                    <Col sm={10}>
                                        <ReactTags tags={this.getFormValue('to')}
                                                   handleDelete={this.noop}
                                                   handleAddition={this.noop}
                                                   suggestions={[]}
                                                   tagComponent={(props)=> <div className='react-tags__selected'><span className="react-tags__selected-tag"><i className={props.tag.icon}/>{props.tag.name}</span></div>}/>
                                    </Col>
                                </FormGroup><br/><br/>
                                <FormGroup controlId="formHorizontalExcluded">
                                    <Col componentClass={ControlLabel} sm={2}>*&nbsp;Excluídos:</Col>
                                    <Col sm={10}>
                                        <ReactTags tags={this.getFormValue('excludedEmailAddresses')}
                                                   handleDelete={this.noop}
                                                   handleAddition={this.noop}
                                                   suggestions={[]}/>
                                    </Col>
                                </FormGroup><br/><br/>
                                <FormGroup>
                                    <Col componentClass={ControlLabel} sm={2}>*&nbsp;Asunto:</Col>
                                    <Col sm={10}>
                                        <FormControl
                                            readOnly={true}
                                            name='subject'
                                            value={ this.getFormValue('subject') }/>
                                    </Col>
                                </FormGroup><br/>
                                <Form horizontal><hr/>
                                    <FormGroup>
                                        <div className='contEditor centered'>
                                            {this.state.header?<div className='header' dangerouslySetInnerHTML={{__html : this.state.header.html}}/>:null}
                                            <div className='body' dangerouslySetInnerHTML={{__html : this.props.emailDocument.body}}/>
                                            {this.state.footer?<div className='footerMail' dangerouslySetInnerHTML={{__html : this.state.footer.html}}/>:null}
                                        </div>
                                    </FormGroup>

                                    <hr/>
                                    <div className='attachments-well'>
                                    {
                                        this.props.emailDocument.attachments.map( (file )=>
                                            <p key={file.id} className='link'><span onClick={this.downloadFile} data-id={file.id}>{file.originalName}</span></p>
                                        )
                                    }
                                    </div>
                                    <hr/>

                                    <Button
                                        bsStyle='success'
                                        onClick={this.props.onHide}
                                        className='pull-right'>Cerrar</Button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}
export default MailDetailModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/components/MailDetailForm/index.jsx